/***
 *
 *   LOADER
 *   Infinite spinning animation for loading states. Matches the ring spinner
 *   used throughout ui-reference.
 *
 *   PROPS
 *   size: pixel diameter (default 24)
 *   absoluteStyle: centre it absolutely in the nearest positioned parent
 *                  (default true, preserved from the previous implementation)
 *   onColor: take the current text colour rather than the brand indigo
 *
 **********/

import { ClassHelper, cn } from 'components/lib';
import Style from './loader.tailwind.js';

export function Loader(props) {
    const { absoluteStyle = true, size = 24 } = props;

    const loaderStyle = ClassHelper(Style, {
        absolute: absoluteStyle,
        className: props.className,
    });

    return (
        <div className={loaderStyle} role="status" aria-live="polite">
            <span
                className={cn(Style.spinner, props.onColor && Style.onColor)}
                style={{ width: size, height: size }}
                aria-hidden
            />
            <span className="sr-only">Loading</span>
        </div>
    );
}
